var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoTeaminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 40",
    width: 72.763,
    height: 47.455
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 326"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 331"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 330"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 284",
    d: "M36.382 0a11.073 11.073 0 1011.073 11.073A11.085 11.085 0 0036.382 0zm0 18.982a7.909 7.909 0 117.909-7.909 7.92 7.92 0 01-7.909 7.909z",
    fill: "#2261da"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 333"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 332"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 285",
    d: "M58.527 12.655a7.909 7.909 0 107.909 7.909 7.92 7.92 0 00-7.909-7.909zm0 12.654a4.745 4.745 0 114.745-4.745 4.751 4.751 0 01-4.745 4.745z",
    fill: "#2261da"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 335"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 334"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 286",
    d: "M14.461 12.655a7.909 7.909 0 107.909 7.909 7.918 7.918 0 00-7.909-7.909zm0 12.654a4.745 4.745 0 114.745-4.745 4.751 4.751 0 01-4.745 4.745z",
    fill: "#2261da"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 337"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 336"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 287",
    d: "M36.382 25.309a20.587 20.587 0 00-20.564 20.564 1.582 1.582 0 003.164 0 17.4 17.4 0 1134.8 0 1.582 1.582 0 003.164 0 20.587 20.587 0 00-20.564-20.564z",
    fill: "#2261da"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 339"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 338"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 288",
    d: "M58.527 31.636a14.237 14.237 0 00-7.374 2.056 1.582 1.582 0 101.642 2.7 11.075 11.075 0 0116.804 9.477 1.582 1.582 0 003.164 0 14.254 14.254 0 00-14.236-14.233z",
    fill: "#2261da"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 341"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 340"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 289",
    d: "M21.608 33.689A14.241 14.241 0 000 45.869a1.582 1.582 0 003.164 0 11.077 11.077 0 0116.8-9.478 1.582 1.582 0 001.642-2.7z",
    fill: "#2261da"
  }))))));
}

export default SvgCoTeaminline;